import { useHistory } from "react-router";
var useWidgetHistory = function () {
    var _a = useHistory(), historyPush = _a.push, historyGoBack = _a.goBack, historyReplace = _a.replace;
    var push = function (url, state, refresh) {
        var _a;
        if (refresh === void 0) { refresh = true; }
        var oldUrl = window.location.href.replace(window.location.origin, "");
        if (oldUrl === url && refresh) {
            window.location.reload();
        }
        else {
            if (window.top !== window.self) {
                (_a = window.top) === null || _a === void 0 ? void 0 : _a.postMessage(JSON.stringify({ action: "push", state: { url: url } }), "*");
            }
            historyPush(url, state);
        }
    };
    var goBack = function () {
        var _a;
        if (window.top !== window.self) {
            (_a = window.top) === null || _a === void 0 ? void 0 : _a.postMessage(JSON.stringify({ action: "goBack" }), "*");
        }
        historyGoBack();
    };
    var replace = function (url, state, refresh) {
        var _a;
        if (refresh === void 0) { refresh = true; }
        var oldUrl = window.location.href.replace(window.location.origin, "");
        if (oldUrl === url && refresh) {
            window.location.reload();
        }
        else {
            if (window.top !== window.self) {
                (_a = window.top) === null || _a === void 0 ? void 0 : _a.postMessage(JSON.stringify({ action: "replace" }), "*");
            }
            historyReplace(url, state);
        }
    };
    return { push: push, goBack: goBack, replace: replace };
};
export default useWidgetHistory;
